import React, { Component } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { withStyles } from '@material-ui/core/styles';
import {isUndefined} from 'lodash'
import './custom.css'

const styles = (theme) => ({
  
  editorStyle: {
    // minHeight: 'calc(100vh - 393px)',
    // minHeight: 'calc(100% - 38px)',
    height: 'calc(100% - 38px)',
    '& .cke_chrome' : { 
      border: 'none',
    },
    '& .cke .cke_bottom' : { 
      backgroundColor: 'transparent',
      borderRadius: '0px 0px 0px 10px' 
    },
    '& .cke .cke_top' : { 
      backgroundColor: 'transparent'
      // borderRadius: '0px 0px 0px 10px' 
    },
    '& .cke .cke_inner' : { 
      backgroundColor: 'transparent'
      // borderRadius: '0px 0px 0px 10px' 
    }
    },
});


class NotEditor extends Component {
    constructor(props) {
        super(props);
        
        this.myRef = React.createRef();
        this.updateContent = this.updateContent.bind(this);
        this.state = {
          content: this.props.commentText,
          config: {
            toolbar: [ { name: 'basicstyles', items: [ 'Bold', 'Italic', 'Underline', 'Strike',  '-', 'RemoveFormat' ] },
            { name: 'paragraph', items: [ 'NumberedList', 'BulletedList','-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl' ] },
            { name: 'insert', items: [  'HorizontalRule' ] },
            { name: 'colors', items: [ 'TextColor', 'BGColor' ] } ,
            { name: 'styles', items: [ 'FontSize' ] }
            
          ],
          // enterMode: window.CKEDITOR.ENTER_BR,
          removePlugins: 'elementspath',
          extraPlugins: "colorbutton,font,justify",
          width: "100%",
          height: isUndefined(this.props.height) ? "250px" : 'calc(100vh - 180px)',
          maxHeight: isUndefined(this.props.height) ? "370px" : 'unset',
          resize_enabled:false,
          font_names :
              'Arial/Arial, Helvetica, sans-serif;' +
              'Times New Roman/Times New Roman, Times, serif;' +
              'Verdana'
          }
        }
      }
    
      updateContent(newContent) {
        this.props.handleupdatecommentText(newContent)
      }
    
      onChange(data) {
        // data = this.getContent()
        // const newContent = evt.editor.getData();
        // this.setState({content: data})
        this.props.handleupdatecommentText(data)
      }
      componentDidUpdate=()=>{
        if(this.state.content !== this.props.commentText){
          this.setState({
            content: this.props.commentText
          })
        }
      }
      render() {
        const { classes} = this.props
        //handleupdatecommentText
        return (
          <div className={classes.editorStyle}>
              <Editor
		  	tabIndex={1}
        tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
			onEditorChange={(value) => {this.onChange(value)}}
			// onChange={(e,v) => {this.onChange(e,v)}}
      onInit={(evt, editor) => {
				// this.myRef.current = editor
      }}
			value={this.props.commentText}
			init={{
        newline_behavior:'invert',
        force_br_newlines : false,
        force_p_newlines : false,
        forced_root_block : '',
				menubar: false,
				inline: false,
				draggable_modal: true,
				resize: false,
				paste_block_drop: false,
        paste_data_images : false,
        paste_as_text: true,
				branding: false,
        statusbar: false,
        
        image_caption: true,
				selector: 'textarea',
        browser_spellcheck: true,
        contextmenu: false,
       	plugins: 
					'advlist autolink lists link image charmap preview anchor ' +
					'searchreplace visualblocks code fullscreen ' +
					'insertdatetime media table help wordcount table ',
				// table_appearance_options: false,
				font_size_formats: "8px 10px 12px 14px 16px 18px 24px 36px 48px 60px 72px 84px 96px 108px 120px",
				// external_plugins: {
				// 	bubbleBar: "http://www.leofec.com/assets/tinymceBubbleBar.js", // file location
				// },
        automatic_uploads: true,
        file_picker_types: 'image',
        file_picker_callback: function (cb, value, meta) {
          var input = document.createElement('input');
          input.setAttribute('type', 'file');
          input.setAttribute('accept', 'image/*');
      
          /*
            Note: In modern browsers input[type="file"] is functional without
            even adding it to the DOM, but that might not be the case in some older
            or quirky browsers like IE, so you might want to add it to the DOM
            just in case, and visually hide it. And do not forget do remove it
            once you do not need it anymore.
          */
      
          input.onchange = function () {
            var file = this.files[0];
      
            var reader = new FileReader();
            reader.onload = function () {
              /*
                Note: Now we need to register the blob in TinyMCEs image blob
                registry. In the next release this part hopefully won't be
                necessary, as we are looking to handle it internally.
              */
              var id = 'blobid' + (new Date()).getTime();
              var blobCache =  window.tinymce.activeEditor.editorUpload.blobCache;
              var base64 = reader.result.split(',')[1];
              var blobInfo = blobCache.create(id, file, base64);
              blobCache.add(blobInfo);
      
              /* call the callback and populate the Title field with the file name */
              cb(blobInfo.blobUri(), { title: file.name });
            };
            reader.readAsDataURL(file);
          };
      
          input.click();
        },

        maxHeight: "600",
            height : "600",
				toolbar: 'undo redo | fontsize  | ' +
				'link fontLight bold italic underline forecolor | bullist numlist alignment outdent indent |' +
				`| help `,
				table_sizing_mode: 'responsive ',
				table_column_resizing: 'resizetable',

				font_family_formats: `
					Titillium=Titillium Web, sans-serif;
					Ubuntu=Ubuntu, Arial, sans-serif;
					Lucida Sans Unicode=Lucida Sans Unicode, Lucida Grande, sans-serif;
					Tahoma=Tahoma, Geneva, sans-serif;
					Times New Roman=Times New Roman, Times, serif;
					Trebuchet MS=Trebuchet MS, Helvetica, sans-serif;
					Verdana=Verdana, Geneva, sans-serif;
					Arial=Arial, Helvetica, sans-serif;
					Calibri=Calibri, sans-serif;
					Open Sans=Open Sans, sans-serif;
					Lato=Lato, sans-serif;
					Montserrat=Montserrat, sans-serif;
          Interstate=Interstate;
          Cabin=Cabin
					`,

				toolbar_groups: {
					formatting: {
					  icon: 'format',
					  tooltip: 'Formateringar',
					  items: 'link bold italic underline backcolor forecolor'
					},
					alignment: {
						icon: 'align-left',
						tooltip: 'Text inriktningar',
						items: ' alignleft aligncenter alignright alignjustify'
					}
				  },

				content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
				language_url: process.env.PUBLIC_URL + '/langsTinymce/sv_SE.js',
        language: 'sv_SE',

				//styleselect -- toolbar
				style_formats: [ 
					{ title: '100', format: 'fw100' },
					{ title: '200', format: 'fw200' },
					{ title: '300', format: 'fw300' },
					{ title: '400', format: 'fw400' },
					{ title: '500', format: 'fw500' },
					{ title: '600', format: 'fw600' },
					{ title: '700', format: 'fw700' },
					{ title: '800', format: 'fw800' },
					{ title: '900', format: 'fw900' },
				],
			}}
		/>
          </div>
        )
      }
}

export default withStyles(styles)(NotEditor);
